import { Toaster as Sonner } from 'sonner'

type ToasterProps = React.ComponentProps<typeof Sonner>

const AppToaster = ({ theme, ...props }: ToasterProps) => {
	return (
		<Sonner
			theme={theme}
			className="toaster group"
			toastOptions={{
				// ADR-025 (9.6): Dutch close label (sonner's default is 'Close toast')
				closeButtonAriaLabel: 'Melding sluiten',
				classNames: {
					// ADR-025 (2.6): a toast is an elevated surface — popover token +
					// the house elevation (hairline ring in dark), house radius
					toast:
						'group toast group-[.toaster]:bg-popover group-[.toaster]:text-popover-foreground group-[.toaster]:border-border group-[.toaster]:rounded-2xl group-[.toaster]:border',
					description: 'group-[.toast]:text-muted-foreground',
					actionButton:
						'group-[.toast]:bg-primary group-[.toast]:text-primary-foreground',
					// ADR-025 (2.9): ink on the muted tint (muted-on-muted was 3.6:1)
					cancelButton:
						'group-[.toast]:bg-muted group-[.toast]:text-foreground',
				},
			}}
			{...props}
		/>
	)
}

export { AppToaster }
